<script lang="ts">
  import {STEP} from '@/types/common';
  import {step} from '@/store';
  import type {Video} from '@/types/project';
  import {onDestroy, onMount} from 'svelte';
  import {recap, project} from '@/store';
  import {CustomTopNavEvent, TopnavEvents, topnav} from '@/utils/top-nav-next-custom-events';
  import {RecapService} from '@/services';
  import {RecapProject} from '@/store/recap';
  import SaveRecapDialog from '@/pages/highlight-recap-subtitles/SaveRecapDialog.svelte';
  import RecapDownloadButton from './RecapDownloadButton.svelte';

  let selectedVideo: Video;

  let isNextDisabled = false;
  let isPreviousDisabled = false;
  let isSaveDialogOpen: boolean = false;
  let projectName: string = '';
  let rawRecapData: RecapProject;

  let nextButton: HTMLButtonElement;
  let previousButton: HTMLButtonElement;

  const recapSubscription = recap.subscribe(value => {
    projectName = value.recap_name;
    rawRecapData = value;
  });

  const projectSubscription = project.subscribe(value => {
    console.log('VALUE', value);
    const projectVideo = value.video;
    if (!projectVideo) return;
    selectedVideo = projectVideo;
  });

  const onPrev = () => {
    if ($step === STEP.HIGHLIGHT_SUBTITLE) return step.update(STEP.CHOOSE_VIDEO);
    window.dispatchEvent(new Event(isPreviousDisabled ? TopnavEvents.disabledPrevious : TopnavEvents.previous));
  };

  function back2Step1() {
    step.update(STEP.CHOOSE_VIDEO);
  }

  function saveProject() {
    isSaveDialogOpen = true;
  }

  onMount(() => {});

  onDestroy(() => {
    recapSubscription();
    projectSubscription();
  });
</script>

<div class="flex h-full w-full gap-4 pl-4">
  <div class="flex gap-4">
    <img class="rounded-lg" src={selectedVideo?.preview} alt="selected-video-thumbnail" />
    <div class="grid w-full max-w-[540px] overflow-hidden text-xs">
      <div class="flex w-full gap-2">
        <button on:click={() => back2Step1()} class="flex items-center gap-1 py-1" title="start over">
          <i class="fa-solid fa-rotate-right"></i>
          <span class="max-w-[200px] truncate">{selectedVideo?.title || 'No Title'}</span>
        </button>
        <div class="flex items-center">
          <i class="fa-solid fa-angle-right"></i>
        </div>
        <button on:click={() => saveProject()} class="flex items-center gap-1 px-2 py-1" title="save project">
          <i class="fa-solid fa-floppy-disk"></i>
          <span class="max-w-[240px] truncate">{projectName}</span>
        </button>
      </div>
      <div class="w-full pt-1.5">
        <div class="flex w-full items-center gap-2">
          {#if $step === STEP.HIGHLIGHT_SUBTITLE}
            <span class="font-bold">Step 1:</span>
            <p>Select & Highlight Subtitles</p>
          {:else if $step === STEP.SELECT_INTRO}
            <span class="font-bold">Step 2:</span>
            <p>Select an Intro</p>
          {:else if $step === STEP.RECAP_PREVIEW}
            <span class="font-bold">Step 3:</span>
            <p>Clip Preview</p>
          {/if}
        </div>
        <div class="flex h-1 w-full max-w-[360px] gap-1 pt-1">
          <div class="h-1 w-full bg-rose-500"></div>
          <div
            class="h-1 w-full {$step === STEP.SELECT_INTRO || $step === STEP.RECAP_PREVIEW
              ? 'bg-rose-500'
              : 'bg-zinc-300'} rounded-lg"
          ></div>
          <div class="h-1 w-full {$step === STEP.RECAP_PREVIEW ? 'bg-rose-500' : 'bg-zinc-300'} rounded-lg"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="relative ml-auto flex gap-2">
    <button
      on:click={() => saveProject()}
      class="flex items-center gap-2 rounded-lg border-zinc-300 px-4 py-2 text-zinc-700 transition-all hover:bg-zinc-200 hover:text-zinc-800"
      style="min-width: 140px;"
    >
      Save Changes
    </button>
    <button
      bind:this={previousButton}
      on:click={onPrev}
      class="{isPreviousDisabled
        ? 'border-zinc-200 text-zinc-300'
        : 'border-zinc-300 text-zinc-700 hover:bg-zinc-200 hover:text-zinc-800'} flex items-center gap-2 rounded-lg border px-4 py-2 transition-all"
    >
      <i class="fa-solid fa-chevron-left"></i>
      Previous
    </button>
    {#if $step === STEP.RECAP_PREVIEW}
      <RecapDownloadButton />
    {:else}
      <div class="relative">
        <div
          class="{isNextDisabled
            ? 'opacity-0'
            : 'pingAnim'} flex h-full items-center gap-2 rounded-lg border border-rose-500 bg-rose-500 px-4 py-2 text-white transition-all hover:bg-rose-600"
        >
          Next
          <i class="fa-solid fa-chevron-right"></i>
        </div>
        <button
          bind:this={nextButton}
          on:click={() =>
            window.dispatchEvent(new Event(isNextDisabled ? TopnavEvents.disabledNext : TopnavEvents.next))}
          class="absolute left-0 top-0 {isNextDisabled
            ? 'border-zinc-300 text-zinc-400'
            : 'border-rose-500 bg-rose-500 text-white hover:bg-rose-600'} flex h-full items-center gap-2 rounded-lg border px-4 py-2 transition-all"
        >
          Next
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    {/if}
  </div>
</div>

<SaveRecapDialog bind:isSaveDialogOpen />

<style>
  .pingAnim {
    animation: pinganimation 500ms forwards;
  }

  @keyframes pinganimation {
    0% {
      scale: 100%;
      opacity: 100%;
    }
    100% {
      scale: 135%;
      opacity: 0%;
    }
  }
</style>
